import { memo, useCallback, useEffect, useState } from 'react'
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { FormatPond } from '../../../context/FreshWater/types'
import { handleColorState } from '../../../helpers/handleColorsState'
import { corporateColor, disabledGray, white } from '../../../theme/colors'
import { Separator } from '../../../components/Separator'
import { Option } from '../../../context/SeaWater/types'
import { InfoState } from '..'

interface OptionsProps {
  item: FormatPond
  isLastItem: boolean
  options: Option[]
  onChange: (value: InfoState) => void
  defaultOptions?: Option
}

export const ListItem = memo(
  ({ item, isLastItem, options, onChange, defaultOptions }: OptionsProps) => {
    const [selected, setSelected] = useState<{ [key: string]: boolean }>({})

    const handleSelected = useCallback((id: number) => {
      setSelected({ [id]: true })
    }, [])

    useEffect(() => {
      if (defaultOptions) {
        onChange({
          levelThreeId: item.id,
          stateId: defaultOptions.id,
          levelThreeName: item.name,
          currentState: item.currentState,
          newState: options.find((o) => o.id === defaultOptions.id)?.name ?? '',
        })
        handleSelected(defaultOptions.id)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
      handleSelected(item.currentStateId)
    }, [item.currentStateId, handleSelected])

    return (
      <>
        <View style={[styles.container, isLastItem && { marginBottom: 100 }]}>
          <View style={{ flex: 0.8 }}>
            <Text style={styles.stateText}>{item.name}</Text>
          </View>
          <View style={{ flex: 1 }}>
            <View style={styles.containerRadioButton}>
              {options.map((option) => (
                <TouchableOpacity
                  style={styles.radioButtonContainer}
                  onPress={() => {
                    onChange({
                      levelThreeId: item.id,
                      stateId: option.id,
                      levelThreeName: item.name,
                      currentState: item.currentState,
                      newState: option.name,
                    })
                    handleSelected(option.id)
                  }}
                  key={option.id}
                >
                  <View
                    style={[
                      styles.radioButton,
                      selected[option.id] && { backgroundColor: handleColorState(option.name) },
                    ]}
                  >
                    <Text style={styles.radioButtonLabel}>{option.name}</Text>
                  </View>
                </TouchableOpacity>
              ))}
            </View>
          </View>
        </View>
        {!isLastItem && <Separator />}
      </>
    )
  },
)

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 5,
  },
  stateText: {
    color: corporateColor,
    fontWeight: 'bold',
  },
  containerRadioButton: {
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    flex: 1,
  },
  radioButton: {
    height: 28,
    width: 50,
    borderRadius: 5,
    borderColor: corporateColor,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
    backgroundColor: disabledGray,
  },
  radioButtonContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  radioButtonLabel: {
    fontSize: 12,
    color: white,
    fontWeight: 'bold',
  },
})
